import { useCallback, useMemo } from 'react';
import { useMessageListRefActions } from 'src/hooks';

export const useMessageByRoundId = (
  conversationId?: string | null,
  roundId?: string | Blob | null,
) => {
  const { getCurrentMessageListRef } = useMessageListRefActions();

  const getMessageByRoundId = useCallback(() => {
    const messageListRef = getCurrentMessageListRef(conversationId);

    return messageListRef.current?.data.find(
      (message) => message.round_id === roundId,
    );
  }, [roundId, conversationId, getCurrentMessageListRef]);

  const message = getMessageByRoundId();

  return useMemo(() => {
    return message;
  }, [message]);
};
